import React, {useState, useEffect} from 'react';
import {db, functions} from '../firebase';

const VistaAdmin = () => {

    const [usuarios, setUsuarios] = useState([])

    useEffect(() => {
        fetchUsuarios()
    }, [])

    const fetchUsuarios = async() => {
        try {
            const res = await db.collection('usuarios').get()
            const arrayUsuarios = res.docs.map(doc => doc.data())
            setUsuarios(arrayUsuarios)

        } catch (error) {
            console.log(error)
        }
    }

    const administrador = (email) => {

        // con esta funcion leemos agregarAdministrador del back-end
        const agregarRol = functions.httpsCallable('agregarAdministrador')

        agregarRol({email: email})
            .then(res => {
                console.log(res)
                if(res.data.error) {
                    console.log('no tiene permisos')
                    return 
                }

                db.collection('usuarios').doc(email).update({rol: 'admin'})
                    .then(user => {
                        console.log('usuario modificado a rol administrador')
                        fetchUsuarios()
                    })
            })

    }

    const crearAutor = email => {
        const agregarRol = functions.httpsCallable('crearAutor')
        agregarRol({email: email})
            .then(res => {
                console.log(res)
                if(res.data.error) {
                    console.log('No tiene permisos')
                    return
                }

                db.collection('usuarios').doc(email).update({rol: 'autor'})
                    .then(user => {
                        console.log('usuario modificado a rol autor')
                        fetchUsuarios()
                    })
            })
    }

    const eliminarAutor = email => {
        const agregarRol = functions.httpsCallable('eliminarAutor')
        agregarRol({email: email})
            .then(res => {
                console.log(res)
                if(res.data.error) {
                    console.log('No tiene permisos')
                    return
                }
                db.collection('usuarios').doc(email).update({rol: 'invitado'})
                    .then(user => {
                        console.log('usuario modificado a invitado')
                        fetchUsuarios()
                    })
            })
    }

    const eliminarAdministrador = email => {
        const agregarRol = functions.httpsCallable('eliminarAdministrador')
        agregarRol({email: email})
            .then(res => {
                console.log(res)
                if(res.data.error) {
                    console.log('No tiene permisos')
                    return
                }
                db.collection('usuarios').doc(email).update({rol: 'invitado'})
                    .then(user => {
                        console.log('usuario modificado a invitado')
                        fetchUsuarios()
                    })
            })
    }

    return (
        <div className="mt-5">
            <h3>Administración de usuarios</h3>
                {
                    usuarios.map(usuario => (
                        <div key={usuario.uid} className="mb-2">
                            {usuario.email} - rol: {usuario.rol}

                            {
                                usuario.rol === 'admin' ? (
                                    <button 
                                        className="btn btn-danger mx-2"
                                        onClick={() => eliminarAdministrador(usuario.email)}
                                    >
                                        Eliminar Administrador
                                    </button>
                                    ) : ( 
                                        <>
                                            <button 
                                                className="btn btn-dark mx-2"
                                                onClick={() => administrador(usuario.email)}
                                            >
                                                Administrador
                                            </button>
                                            
                                            <button 
                                                className="btn btn-success mx-2"
                                                onClick={() => crearAutor(usuario.email)}
                                            >
                                                Autor
                                            </button>

                                            <button 
                                                className="btn btn-info mx-2"
                                                onClick={() => eliminarAutor(usuario.email)}
                                            >
                                                Invitado
                                            </button>
                                        </>
                                    )
                            }
                        </div>
                    ))
                }
        </div>
    )
}

export default VistaAdmin
